import React from 'react';
import Copy from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/icons/copy.svg';
import CopyGold from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/icons/copy-gold.svg';
import Icon from 'components/canvas/components/icon';
import { useTranslation } from 'i18n';
import { useCanvasClipboardOperations } from 'state/canvas-clipboard';
import { useSelectedNodeOperations } from 'state/canvas/selected-node';
import { toast } from 'services/toast';
import { KonvaEventObject } from 'konva/lib/Node';
import { SurfaceNodeUnion } from 'graphql/types';

export interface CopyIconProps {
  node?: SurfaceNodeUnion;
  isSelected?: boolean;
  onClick?: (event: KonvaEventObject<MouseEvent>) => void;
  width?: number;
  height?: number;
}

const defaultProps = {
  isSelected: false,
};

function CopyIcon(props: CopyIconProps) {
  const { t } = useTranslation();
  const { node } = props;
  const { addNodesForCopyToClipboard } = useCanvasClipboardOperations();
  const { clearSelectedNode } = useSelectedNodeOperations();
  const [isSelected, setSelected] = React.useState<boolean>(false);

  const src = isSelected ? CopyGold : Copy;

  function copyNode(node) {
    if (node) {
      toast.success(
        t(`Successfully added node {{name}} to clipboard.`, {
          replace: { name: node?.name || '' },
        }),
      );
      addNodesForCopyToClipboard([node]);
      clearSelectedNode();
    }
  }

  function onClick(event) {
    event.cancelBubble = true;

    if (node) {
      copyNode(node);
    }

    props.onClick && props.onClick(event);
  }

  return (
    <Icon
      {...props}
      src={src}
      onClick={onClick}
      onMouseOver={() => setSelected(true)}
      onMouseOut={() => setSelected(false)}
    />
  );
}

CopyIcon.defaultProps = defaultProps;

export default CopyIcon;
